export const sampleSchema = {
  name: 'Seasonality Schema',
  type: 'object',
  properties: {
    Name: {
      type: 'string',
      required: true,
      maxLength: 255,
    },
    Description: {
      type: 'string',
      maxLength: 1000,
    },
    AdjustmentPercentage: {
      // type: 'number',
      // seems like this is totally useless
      type: 'decimal',
      required: true,
      minimum: 0,
      maximum: 900,
    },
  },
};
